import React from "react";
function Partners() {
    return (
        <section className="partners bg-6 alpha-4 b-b">
            <div className="section-heading mb-6 text-center">
                <h5 className="accent bold small text-uppercase">
                    Ellos confian en nosotros{" "}
                </h5>
                <h2>Aliados y clientes</h2>
            </div>
            <div className="container py-5 " style={{ backgroundColor: "#fc6d57" }}>
                <div className="swiper-container" data-sw-show-items="5" data-sw-space-between="30" data-sw-autoplay="2500" data-sw-loop="true">
                    <div className="swiper-wrapper align-items-center">
                        <div className="swiper-slide">
                            <a href="https://slide.com.mx/es" target="_blank" rel="noreferrer">
                                <img src="images/partners/slide.png" className="img-responsive" alt="Slide Technology" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://californiavivelamusica.live/" target="_blank" rel="noreferrer">
                                <img src="images/partners/californiaViveLaMusica.png" className="img-responsive" alt="California Vive la Música" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://bidlab.org/es" target="_blank" rel="noreferrer">
                                <img src="images/partners/bidlab.png" className="img-responsive" alt="BID LAB" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.talent-network.org/" target="_blank" rel="noreferrer">
                                <img src="images/partners/talentNetwork.png" className="img-responsive" alt="Talent Network" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.lacchain.net/" target="_blank" rel="noreferrer">
                                <img src="images/partners/lacchain.png" className="img-responsive" alt="LACChain" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.kionetworks.com/" target="_blank" rel="noreferrer">
                                <img src="images/partners/kio.webp" className="img-responsive" alt="KIO Networks" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.retozapopan.com.mx/" target="_blank" rel="noreferrer">
                                <img src="images/partners/retoZapopan.png" className="img-responsive" alt="Reto Zapopan" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://creativewomen.co/" target="_blank" rel="noreferrer">
                                <img src="images/partners/creative women.png" className="img-responsive" alt="Creative women" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://educa.org.mx/" target="_blank" rel="noreferrer">
                                <img src="images/partners/educa.png" className="img-responsive" alt="Fundación Educa" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.fuckupnights.com/" target="_blank" rel="noreferrer">
                                <img src="images/partners/fuckup.png" className="img-responsive" alt="Fuckup" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://theglobalhack.devpost.com/" target="_blank" rel="noreferrer">
                                <img src="images/partners/globalhack.png" className="img-responsive" alt="Global hack" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.globant.com/" target="_blank" rel="noreferrer">
                                <img src="images/partners/globant.png" className="img-responsive" alt="Globant" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://masschallenge.org/" target="_blank" rel="noreferrer">
                                <img src="images/partners/mass challenge.png" className="img-responsive" alt="Mass Challenge" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://metaversemexico.mx/" target="_blank" rel="noreferrer">
                                <img src="images/partners/metaverse.png" className="img-responsive" alt="Metaverse" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://fundacionmisangre.org/" target="_blank" rel="noreferrer">
                                <img src="images/partners/mi sangre.png" className="img-responsive" alt="Mi Sangre" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.instagram.com/comunidadmrcoin/" target="_blank" rel="noreferrer">
                                <img src="images/partners/mrcoin.png" className="img-responsive" alt="Mr Coin" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="https://www.nosolosoftware.es/" target="_blank" rel="noreferrer">
                                <img src="images/partners/nosolosoftware.png" className="img-responsive" alt="No solo software" style={{ maxHeight: "80px", margin: "auto" }} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Partners;

